<div>

    <label class="bold">{{ l('AssetAndControlAccount') }}
        <button class="btn btn-sm d-inline-block"
                [disabled]="controlDisabled"
                (click)="controlsSelector.open()">
            <i class="fa fa-edit"></i>
        </button>
    </label>
    <span class="coloured d-block">
        <span class="d-inline-block" style="margin-right: 25px;">{{ assetCode }}</span>
        <span class="d-inline-block">{{ controllingStructureCode }}</span>
    </span>
    
    <div style="opacity: 0; pointer-events: none; height: 0px;">
        <mat-form-field>
            <mat-select [formControl]="controlsFormCtrl"
                        [multiple]="false"
                        #controlsSelector>
                <mat-option>
                    <ngx-mat-select-search
                        noEntriesFoundLabel="No results found"
                        placeholderLabel="Find control account..."
                        [formControl]="controlsFilterForm">
                    </ngx-mat-select-search>
                </mat-option>
                <div class="indicators">                    
                    <label class="label-color">{{ l("Recent") }}  </label>                                     
                    <button type="button" class="btn btn-link"
                    (click)="ClearRecent()">{{l("Clear")}}</button>
                </div>
                <div *ngFor="let control of filteredControls | async">
                    <mat-option 
                    [value]="control"
                    *ngIf="control.controllingStructure.wasRecentlyAssigned"
                    class="cust-mat-option"
                    (click)="selectControl(control)"
                    [matTooltip]="control.controllingStructure.name + ' (' + control.controllingStructure.accId + ')'">
                            ({{ control.controllingStructure.accId}})
                            {{ control.controllingStructure.name }}
                    </mat-option>
                </div>
                <div class="indicators">                 
                    <label class="label-color">{{ l("All") }}  </label> 
                </div>
                <div *ngFor="let control of filteredControls | async">
                    <mat-option 
                    [value]="control"
                    *ngIf="!control.controllingStructure.wasRecentlyAssigned"
                    class="cust-mat-option"
                    (click)="selectControl(control)"
                    [matTooltip]="control.controllingStructure.name + ' (' + control.controllingStructure.accId + ')'">
                            ({{ control.controllingStructure.accId}})
                            {{ control.controllingStructure.name }}
                    </mat-option>
                </div>
            </mat-select>
        </mat-form-field>
    </div>

    <!--
    <button class="btn coloured"
            style="padding-left: 0;"
            *ngIf="isAssetModified"
            (click)="applyAll(activityDayId)">
        <i class="fas fa-calendar-check"></i> {{ l('ApplyAll') }}
    </button>
    -->
    <div class="validation" *ngIf="!controllingStructureCode">{{ l('SelectAssetControl') }}</div>
</div>
